import React from 'react';
import { Modal, Card, Button, Space, Typography } from 'antd';
import { MailOutlined, EditOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/**
 * 发布邮件模板选择模态框
 * 让用户选择是发送新发布邮件还是更新发布邮件
 */
const PublishTemplateSelectionModal = ({ 
    visible, 
    onClose, 
    onSelectTemplate 
}) => {
    const handleTemplateSelect = (templateCode) => {
        onSelectTemplate(templateCode);
        onClose();
    };

    return (
        <Modal
            title="选择发布邮件模板"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <div style={{ marginBottom: 16 }}>
                <Text type="secondary">
                    请选择适合的发布邮件模板类型：
                </Text>
            </div>

            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Card
                    hoverable
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleTemplateSelect('SCHEDULE_OUTSTATION_NEW_PUBLICATION')}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                        <MailOutlined 
                            style={{ 
                                fontSize: 32, 
                                color: '#1890ff',
                                padding: 8,
                                backgroundColor: '#e6f7ff',
                                borderRadius: 8
                            }} 
                        />
                        <div style={{ flex: 1 }}>
                            <Title level={4} style={{ margin: 0, marginBottom: 8 }}>
                                新发布计划
                            </Title>
                            <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                                用于首次发布航班计划给外站服务团队
                            </Text>
                            <Text 
                                style={{ 
                                    fontSize: 12, 
                                    color: '#666',
                                    fontStyle: 'italic'
                                }}
                            >
                                示例主题：9H-WFF & 9H-FLM JULY Schedule // FlyMeta / Air Atlanta
                            </Text>
                        </div>
                        <Button type="primary">
                            选择此模板
                        </Button>
                    </div>
                </Card>

                <Card
                    hoverable
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleTemplateSelect('SCHEDULE_OUTSTATION_UPDATE_PUBLICATION')}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                        <EditOutlined 
                            style={{ 
                                fontSize: 32, 
                                color: '#faad14',
                                padding: 8,
                                backgroundColor: '#fff7e6',
                                borderRadius: 8
                            }} 
                        />
                        <div style={{ flex: 1 }}>
                            <Title level={4} style={{ margin: 0, marginBottom: 8 }}>
                                更新发布计划
                            </Title>
                            <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                                用于发布航班计划变更给外站服务团队
                            </Text>
                            <Text 
                                style={{ 
                                    fontSize: 12, 
                                    color: '#666',
                                    fontStyle: 'italic'
                                }}
                            >
                                示例主题：9H-WFF JUN schedule update on 16-Jun
                            </Text>
                        </div>
                        <Button type="primary">
                            选择此模板
                        </Button>
                    </div>
                </Card>
            </Space>
        </Modal>
    );
};

export default PublishTemplateSelectionModal; 